import { gql } from "apollo-boost"

export const getApprovedByRegion = gql`
  query ProjectsTotalsDashboards($where: DashboardProjectsWhere) {
    ApprovedByRegion(where: $where) {
      region
      totalAmount
    }
    ApprovedByRegionAndAxis(where: $where) {
      region
      StrategicAxisCount {
        count
        region
        totalAmount
        strategicAxis
      }
    }
  }
`